/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Flex, Pane, TextInput } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { Validator } from '@leverege/validator';
import useForm from "./hooks/useForm.js";
import useLoginByCode from "./hooks/useLoginByCode.js";
import { LoginByCodeDefaultProps } from "./Constants.js";
import FieldErrorsComponent from "./views/FieldErrorsComponent.js";
import S from './Login.css';
const {
  t,
  tf
} = I18N.ns('login.LoginByCode');
export default function LoginByCode(props) {
  const {
    classNames: {
      className,
      backClassName,
      codeClassName,
      submitClassName,
      warningClassName
    },
    components: {
      ErrorComponent,
      LoadingComponent,
      LogoComponent,
      LoginByCodeInstructionComponent
    },
    variants: {
      variant,
      backToLoginVariant,
      codeVariant,
      loginLogoVariant,
      warningVariant
    },
    options: {
      getShouldDisplayLogo,
      warningLocation
    },
    state: {
      error,
      loading,
      onSubmit: pOnSubmit
    },
    onBackToLogin
  } = useLoginByCode(props);
  const {
    values,
    errors,
    onChange,
    onSubmit
  } = useForm({
    fields: {
      code: {
        validator: Validator.required,
        errorMessage: tf('codeError')
      }
    },
    onSubmit: pOnSubmit
  });
  const displayLogo = getShouldDisplayLogo(props, 'login/loginByCode');
  return /*#__PURE__*/React.createElement(Pane, {
    variant: variant,
    className: className,
    layout: "flex:colS"
  }, /*#__PURE__*/React.createElement(Flex, {
    inline: true,
    variant: "colM",
    align: "center"
  }, displayLogo && LogoComponent ? /*#__PURE__*/React.createElement(LogoComponent, {
    variant: loginLogoVariant
  }) : null, /*#__PURE__*/React.createElement(Pane, {
    variant: "loginPaneHalf",
    layout: "flex:colMCenter"
  }, warningLocation === 'top' && ErrorComponent ? /*#__PURE__*/React.createElement(ErrorComponent, {
    variant: warningVariant,
    className: warningClassName,
    error: error
  }) : null, LoginByCodeInstructionComponent && /*#__PURE__*/React.createElement(LoginByCodeInstructionComponent, null), /*#__PURE__*/React.createElement("form", {
    className: S.form,
    onSubmit: e => e.preventDefault()
  }, /*#__PURE__*/React.createElement(Flex, {
    variant: "colM",
    align: "stretch"
  }, /*#__PURE__*/React.createElement(TextInput, {
    variant: codeVariant,
    className: codeClassName,
    alwaysFireOnReturn: true,
    value: values.code,
    hint: t('codeHint'),
    onChange: onChange,
    eventData: "code",
    autoComplete: "one-time-code"
  }), /*#__PURE__*/React.createElement(FieldErrorsComponent, {
    errors: errors.code
  }), /*#__PURE__*/React.createElement(Button, {
    className: submitClassName,
    type: "submit",
    onClick: onSubmit
  }, loading ? /*#__PURE__*/React.createElement(LoadingComponent, null) : t('submit')), /*#__PURE__*/React.createElement(Button, {
    variant: backToLoginVariant,
    className: backClassName,
    type: "button",
    onClick: onBackToLogin
  }, t('backText')))))));
}
LoginByCode.propTypes = {
  classNames: PropTypes.exact({
    className: PropTypes.string,
    warningClassName: PropTypes.string
  }),
  components: PropTypes.exact({
    ErrorComponent: PropTypes.elementType,
    LoadingComponent: PropTypes.elementType,
    LoginByCodeInstructionComponent: PropTypes.elementType,
    LogoComponent: PropTypes.elementType
  }),
  options: PropTypes.exact({
    getShouldDisplayLogo: PropTypes.func,
    warningLocation: PropTypes.string
  }),
  variants: PropTypes.exact({
    variant: PropTypes.string,
    backToLoginVariant: PropTypes.string,
    loginLogoVariant: PropTypes.string,
    warningVariant: PropTypes.string
  })
};